<template>
  <div>
    <create-task :pbn="selectedPbn" :order="order" type="content" :data="{title: 'Add content'}"></create-task>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Pbn</th>
        <th>Client</th>
        <th>Group</th>
        <th>Last Post</th>
        <th>Hosting</th>
        <th>Posts</th>
        <th>Languages</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="pbn in pbns" :key="pbn.id">
        <td><pbn :pbn="pbn"></pbn></td>
        <td>{{ pbn.client.name }}</td>
        <td>{{ pbn.group ? pbn.group.name : '/' }}</td>
        <td>{{ pbn.content.lastUpdate | aTime('from') }}</td>
        <td>{{ pbn.hosting ? pbn.hosting.name : '?' }}</td>
        <td>{{ pbn.content.contentCount }}</td>
        <td>{{ pbn.language.join(',') }}</td>
        <td>
          <button class="btn btn-xs btn-primary" data-toggle="modal" data-target="#create-task" @click="selectedPbn = pbn"><i class="fa fa-plus"></i> Task</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import CreateTaskModal from '../CreateTaskModal'
import PbnListItem from '../../../Pbn/PbnListItem'

export default {
  data () {
    return {
      pbns: [],
      task: {},
      selectedPbn: {}
    }
  },
  components: {
    createTask: CreateTaskModal,
    pbn: PbnListItem
  },
  computed: {
    ...mapGetters({
      order: 'getMaintenanceOrder',
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.users) {
      this.$store.dispatch('loadFilters')
    }
    this.loadPbns()
  },
  methods: {
    loadPbns () {
      axios.get(`/maintenance/order/${this.order.id}/content-pbns`)
        .then(r => {
          this.pbns = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order/Tabs/Content.vue